import { atom } from "recoil";

const clientFormRefillStatusAtom = atom({
  key: "clientFormRefillStatus",
  default: false,
});

export default clientFormRefillStatusAtom;
